<div class="not-found-wrapper">
  <h1 class="display-1 fw-bold text-dark mb-0">404</h1>
  <h2 class="h4 fw-semibold mb-3">Página no encontrada</h2>
  <p class="text-muted mb-4">La página que buscas no existe o fue movida a otro lado.</p>
  <app-button text="Ir a inicio" icon="home" href="/" />
</div>
